module.exports = __webpack_public_path__ + "assets/link.9117cfda.svg";